"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const d3 = __importStar(require("d3"));
const lodash_1 = __importDefault(require("lodash"));
const color_1 = __importDefault(require("color"));
const resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
const Tooltip_1 = __importDefault(require("../Tooltip"));
require("./style.scss");
const constants_1 = require("../../constants");
const chart_helpers_1 = require("../../util/chart.helpers");
const InfoTooltip_1 = __importDefault(require("../InfoTooltip"));
const error_1 = require("../error");
const Triggerable_1 = __importDefault(require("../../util/Triggerable"));
const radius = 20;
function createScale(data, year, width, _ref) {
  let {
    domain,
    reverse
  } = _ref;
  const values = (0, lodash_1.default)(data).map('metric').flatMap(d => d.data.map(dd => ({
    ...dd,
    type: d.xType
  }))).filter(_ref2 => {
    let {
      key,
      type
    } = _ref2;
    return key.getTime() === (0, chart_helpers_1.dateParser)(year, type).getTime();
  }).map('value').value();
  const scaleDomain = domain || [lodash_1.default.min(values), lodash_1.default.max(values)];
  return d3.scaleLinear(reverse ? lodash_1.default.reverse(lodash_1.default.clone(scaleDomain)) : scaleDomain, [radius, width - radius]).nice();
}
function format(func, value, options) {
  if (value === undefined || value === null) {
    return 'N/A';
  }
  return func(value, options);
}
function createAxis(drawParams, scale, selection, height) {
  const {
    params: {
      vertical,
      axisValues,
      margins: {
        bottom,
        left
      }
    }
  } = drawParams;
  selection.selectAll('*').remove();
  const axis = vertical ? d3.axisLeft(scale) : d3.axisBottom(scale);
  axis.tickSizeOuter(0).tickFormat((0, chart_helpers_1.valueFormat)(drawParams));
  if (axisValues) {
    axis.tickValues(axisValues);
  }
  selection.style('transform', vertical ? `translateX(${left}px)` : `translateY(${height - bottom}px)`);
  return selection.call(axis);
}
function showTooltip(d, drawParams) {
  const {
    metric,
    x,
    y,
    primaryColor,
    tooltipTitle
  } = d;
  const {
    params: {
      tooltipOptions: {
        customTooltip
      }
    }
  } = drawParams;
  const containerDim = this.container.node().getBoundingClientRect();
  const svgDim = this.svg.node().getBoundingClientRect();
  const tooltipColour = (0, chart_helpers_1.getColour)({
    primaryColor
  }, 0, drawParams);
  let titles = {};
  let content;
  if (customTooltip !== undefined) {
    content = [{
      type: 'value',
      value: customTooltip(d, (0, chart_helpers_1.dateParser)(this.dropdownSelected, metric.xType)),
      html: true
    }];
  } else {
    const formatFunc = (0, chart_helpers_1.tooltipFormat)(drawParams);
    const {
      value
    } = lodash_1.default.find(metric.data, _ref3 => {
      let {
        key
      } = _ref3;
      return key.getTime() === (0, chart_helpers_1.dateParser)(this.dropdownSelected, metric.xType).getTime();
    });
    const formattedValue = format(formatFunc, value);
    titles = {
      title: {
        value: tooltipTitle ?? metric.geo_name
      },
      subtitle: {
        value: this.dropdownSelected
      }
    };
    content = [{
      type: 'value',
      value: formattedValue
    }];
  }
  this.tooltip.draw(x - containerDim.left + svgDim.left, y - containerDim.top + svgDim.top, titles, content, {
    primaryColour: tooltipColour
  }, 4);
}
function drawContent(drawParams) {
  this.cachedParams = drawParams;
  this.height = this.container.node().getBoundingClientRect().height;
  const {
    params: {
      margins,
      vertical,
      info,
      hideYear,
      hideTitle,
      domain
    }
  } = drawParams;
  this.container.classed('vertical', vertical);
  let {
    data
  } = drawParams;
  const {
    params
  } = drawParams;
  const scale = createScale(data, this.dropdownSelected, vertical ? this.height : this.width, {
    domain,
    reverse: vertical
  });
  const value = _ref4 => {
    let {
      metric
    } = _ref4;
    const foundTimeData = lodash_1.default.find(metric.data, _ref5 => {
      let {
        key
      } = _ref5;
      return key.getTime() === (0, chart_helpers_1.dateParser)(this.dropdownSelected, metric.xType).getTime();
    }) || {};
    return foundTimeData.value;
  };
  const scaledPosition = _ref6 => {
    let {
      metric
    } = _ref6;
    return scale(value({
      metric
    }));
  };
  const zeroPosition = () => vertical ? (margins.left + this.width - margins.right) / 2 : this.height / 2;
  data = lodash_1.default.map(data, d => ({
    ...d,
    x: vertical ? this.width : scaledPosition,
    vx: 0,
    y: vertical ? scaledPosition : zeroPosition,
    vy: 0
  }));
  d3.forceSimulation(data).force('x', d3.forceX().strength(d => {
    if (vertical) {
      return 0.045;
    }
    // return Math.abs(value(d)) < 0.5 ? 1 : 0.4;
    return Math.max(1 / (1 + Math.abs(value(d)) ** 3), 0.2);
  }).x(vertical ? zeroPosition : scaledPosition)).force('y', d3.forceY().strength(d => {
    if (vertical) {
      return Math.max(1 / (1 + Math.abs(value(d)) ** 3), 0.2);
    }
    return 0.06;
  }).y(vertical ? scaledPosition : zeroPosition)).force('collision', d3.forceCollide().radius(_ref7 => {
    let {
      ratioToMaxSize = 1
    } = _ref7;
    return Math.sqrt(ratioToMaxSize) * radius + 2;
  })).stop().tick(300);
  this.outlines.selectAll('circle').data(data).join(enter => enter.append('circle').attr('cx', _ref8 => {
    let {
      x
    } = _ref8;
    return x;
  }).attr('cy', _ref9 => {
    let {
      y
    } = _ref9;
    return y;
  }).attr('r', 0)).style('display', _ref10 => {
    let {
      fips
    } = _ref10;
    return lodash_1.default.includes(params.selectedStates, fips) ? null : 'none';
  }).attr('fill', 'white').attr('stroke', 'black').attr('stroke-width', 1).transition().duration(params.transitionDuration).attr('cx', _ref11 => {
    let {
      x
    } = _ref11;
    return x;
  }).attr('cy', _ref12 => {
    let {
      y
    } = _ref12;
    return y;
  }).attr('r', _ref13 => {
    let {
      ratioToMaxSize = 1
    } = _ref13;
    return Math.sqrt(ratioToMaxSize) * radius + 1.5;
  });
  this.circles.selectAll('circle').data(data).join(enter => enter.append('circle').attr('cx', _ref14 => {
    let {
      x
    } = _ref14;
    return x;
  }).attr('cy', _ref15 => {
    let {
      y
    } = _ref15;
    return y;
  }).attr('r', 0)).attr('fill', d => (0, chart_helpers_1.getColour)(d, 0, params)).transition().duration(params.transitionDuration).attr('cx', _ref16 => {
    let {
      x
    } = _ref16;
    return x;
  }).attr('cy', _ref17 => {
    let {
      y
    } = _ref17;
    return y;
  }).attr('r', _ref18 => {
    let {
      ratioToMaxSize = 1
    } = _ref18;
    return Math.sqrt(ratioToMaxSize) * radius;
  });
  this.circles.selectAll('circle').on('mousemove', lodash_1.default.throttle((event, d) => {
    showTooltip.call(this, d, drawParams);
    event.stopPropagation();
  }, constants_1.THROTTLE, {
    trailing: false
  }), {
    passive: true
  }).on('click', (event, d) => {
    this.trigger('circleClicked', d);
    event.stopPropagation();
  }, {
    passive: true
  }).on('mouseout', () => {
    this.tooltip.hide();
  }, {
    passive: true
  });
  this.labels.selectAll('text').data(data).join(enter => enter.append('text').attr('x', _ref19 => {
    let {
      x
    } = _ref19;
    return x;
  }).attr('y', _ref20 => {
    let {
      y
    } = _ref20;
    return y;
  }).attr('opacity', 0)).attr('fill', d => (0, color_1.default)((0, chart_helpers_1.getColour)(d, 0, params)).isDark() ? 'white' : 'black').transition().duration(params.transitionDuration).attr('opacity', 1).attr('x', _ref21 => {
    let {
      x
    } = _ref21;
    return x;
  }).attr('y', _ref22 => {
    let {
      y
    } = _ref22;
    return y;
  }).attr('dy', '0.35em').text(_ref23 => {
    let {
      labelText = ''
    } = _ref23;
    return labelText;
  });
  if (!hideTitle) {
    if (hideYear) {
      chart_helpers_1.drawTitle.call(this, this.title, this.subtitle, drawParams, null);
    } else {
      chart_helpers_1.drawTitle.call(this, this.title, this.subtitle, drawParams, this.dropdownSelected);
    }
  }
  createAxis(drawParams, scale, this.axis, this.height);
  this.trigger('updatedScale', scale);
  if (info && info.position === 'chart') {
    InfoTooltip_1.default.inChart(this.container, {
      info
    });
  }
}
function initElements(container) {
  const title = container.append('div').classed('chart-title', true);
  const subtitle = container.append('div').classed('chart-subtitle', true);
  const svg = container.classed('beeswarm', true).classed('dh-chart-wrapper', true).append('svg');
  const outlines = svg.append('g').classed('outlines', true);
  const circles = svg.append('g').classed('circles', true);
  const labels = svg.append('g').classed('labels', true);
  const axis = svg.append('g').classed('axis', true);
  return {
    title,
    subtitle,
    svg,
    outlines,
    circles,
    labels,
    axis
  };
}
class Beeswarm extends Triggerable_1.default {
  constructor(container) {
    super();
    this.chartType = constants_1.CHART_TYPES.Beeswarm;
    this.cssPrefix = 'beeswarm';
    this.dropdownSelected = null;
    this.margins = {
      top: 20,
      bottom: 20,
      left: 40,
      right: 20
    };
    this.width = 960;
    this.container = container;
    if (this.container === undefined) {
      this.draw = this.drawCanvas;
      return;
    }
    ({
      title: this.title,
      subtitle: this.subtitle,
      svg: this.svg,
      outlines: this.outlines,
      circles: this.circles,
      labels: this.labels,
      axis: this.axis
    } = initElements(container));
    this.hoveredArea = null;
    this.tooltip = new Tooltip_1.default(container);
    this.svg.on('click', () => this.tooltip.hide(), {
      passive: true
    });
    error_1.initError.call(this);
    this.ro = new resize_observer_polyfill_1.default(entries => {
      entries.forEach(entry => {
        const {
          width: containerWidth,
          height: containerHeight
        } = entry.contentRect;
        requestAnimationFrame(() => {
          this.width = containerWidth;
          this.height = containerHeight;
          this.redrawContent();
        });
      });
    });
    this.ro.observe(container.node());
  }
  setDropdownSelected(key) {
    this.dropdownSelected = key;
  }
  redrawContent() {
    if (this.cachedParams) {
      drawContent.call(this, this.cachedParams);
    }
  }
  async data(promises, options) {
    const fetched = await error_1.tryChartPromises.call(this, promises);
    if (!fetched) return null;
    const {
      data,
      parent
    } = fetched;
    const startDate = options.startDate || options.startYear;
    const endDate = options.endDate || options.endYear;
    let keysAreDates = true;
    const keys = (0, lodash_1.default)(data).flatMap(d => d.metric.data.map(_ref24 => {
      let {
        key
      } = _ref24;
      if (d.metric.xType && d.metric.xType.toLowerCase() === 'items') {
        keysAreDates = false;
      }
      return {
        key,
        xType: d.metric.xType
      };
    })).filter(v => {
      if (v.xType && v.xType.toLowerCase() === 'items') return true;
      if (startDate && v.key.getTime() < (0, chart_helpers_1.dateParser)(startDate, v.xType).getTime()) {
        return false;
      }
      if (endDate && v.key.getTime() > (0, chart_helpers_1.dateParser)(endDate, v.xType).getTime()) {
        return false;
      }
      return true;
    }).map(v => (0, chart_helpers_1.dateFormat)(v.key, v.xType)).uniq().value();
    const selectedDropdown = options.selectedDropdown || options.selectedYear;
    if (this.dropdownSelected === null || !keys.includes(this.dropdownSelected)) {
      if (selectedDropdown !== undefined && keys.includes(selectedDropdown.toString())) {
        this.dropdownSelected = selectedDropdown;
      } else if (!keysAreDates) {
        this.dropdownSelected = lodash_1.default.first(keys);
      } else {
        this.dropdownSelected = lodash_1.default.maxBy(keys, d => new Date(d));
      }
    }
    if (options.forceYear && keys.includes(options.forceYear.toString())) {
      this.dropdownSelected = options.forceYear;
    }
    return {
      data,
      parent,
      keys
    };
  }
  getDrawParams(_ref25) {
    let {
      data,
      parent,
      options: {
        selectedStates = [],
        vertical = false,
        tooltipOptions: {
          customTooltip = undefined
        } = {},
        domain = undefined,
        hideDropdown = false,
        selectableDropdowns = true,
        hideTitle = false,
        transitionDuration = 500,
        ...otherOptions
      }
    } = _ref25;
    return {
      ...(0, chart_helpers_1.getDefaultDrawParams)({
        data,
        parent,
        options: otherOptions
      }, this.margins),
      selectedStates,
      vertical,
      tooltipOptions: {
        customTooltip
      },
      domain,
      hideDropdown,
      selectableDropdowns,
      hideTitle,
      transitionDuration
    };
  }
  async draw(promises) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const allData = await this.data(promises, options);
    if (!allData) return false;
    const {
      data,
      parent,
      keys
    } = allData;
    const optionParams = this.getDrawParams({
      data,
      parent,
      options
    });
    optionParams.selectableYears = Object.prototype.hasOwnProperty.call(options, 'selectableYears') ? options.selectableYears : true;
    const drawParams = {
      data,
      parent,
      params: optionParams,
      keys
    };
    if (optionParams.titleVerticalPosition === 'top') {
      this.title.classed('below', false);
      this.container.node().insertBefore(this.title.node(), this.svg.node());
      this.container.node().insertBefore(this.subtitle.node(), this.svg.node());
    } else if (optionParams.titleVerticalPosition === 'bottom') {
      this.title.classed('below', true);
      this.container.node().append(this.title.node());
      this.container.node().append(this.subtitle.node());
    }
    drawContent.call(this, drawParams);
    return true;
  }
}
exports.default = Beeswarm;